import React from "react"

import { getImageURL } from "../../../helpers"

import "../../../css/Common.css"

function Header() {
    const logo =
        getImageURL(process.env.REACT_APP_LOGOS, "landingHeader") || getImageURL(process.env.REACT_APP_LOGOS, "header")
    const logoClassName = process.env.REACT_APP_COMPANY
        ? `landing_logo_${process.env.REACT_APP_COMPANY?.toLowerCase()}`
        : ""

    return (
        <div>
            <a href={process.env.REACT_APP_COMPANY_URL} rel="noopener noreferrer" target="_blank">
                <img src={logo} alt="logo" className={`landing_logo_image ${logoClassName}`} />
            </a>
        </div>
    )
}

export default Header
